import React from 'react';
import { connect } from 'react-redux';
import IconButton from '../common/icon-button';
import { palette } from '../../papaya-theme';
import {
  fragmentDeleteVote,
  fragmentVote,
} from '../../reducers/booklet.reducer';

import styles from './vote.module.css';
import Icon from '../../assets/icons/Icon';

export const VOTE_TYPES = {
  LIKE: 'like',
  DISLIKE: 'dislike',
};

class Vote extends React.Component {
  handleVote = (event, vote) => {
    event.stopPropagation();
    const {
      dispatch,
      bookletId,
      sectionId,
      sectionIndex,
      fragment,
      fragmentIndex,
      childIndex = null,
      token,
    } = this.props;
    if (fragment.currentUserVote === vote) {
      //remove vote
      dispatch(
        fragmentDeleteVote(
          bookletId,
          sectionId,
          sectionIndex,
          fragment,
          fragmentIndex,
          childIndex,
          token
        )
      );
    } else {
      dispatch(
        fragmentVote(
          bookletId,
          sectionId,
          sectionIndex,
          fragment,
          fragmentIndex,
          vote,
          childIndex,
          token
        )
      );
    }
  };

  render() {
    const { show, fragment, loggedUser, share } = this.props;

    if (
      !show ||
      // user is not logged and doesn't have per email share
      // commenting is disabled in public share
      (!loggedUser.id && (share.email === 'public' || share.email === null)) ||
      // admin cannot vote
      loggedUser.isAdmin
    )
      return null;

    return (
      <div className={styles.vote}>
        <IconButton
          tooltip="Like"
          onClick={event => this.handleVote(event, VOTE_TYPES.LIKE)}
        >
          <Icon
            name="save"
            fill={
              fragment.currentUserVote === VOTE_TYPES.LIKE
                ? palette.green
                : palette.grey
            }
          />
        </IconButton>
        <IconButton
          tooltip="Dislike"
          onClick={event => this.handleVote(event, VOTE_TYPES.DISLIKE)}
        >
          <Icon
            name="cancel"
            color={
              fragment.currentUserVote === VOTE_TYPES.DISLIKE
                ? palette.red
                : palette.grey
            }
            hoverColor={palette.red}
          />
        </IconButton>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  bookletId: state.booklet.id,
  share: state.booklet.share,
  token: state.booklet.token,
  loggedUser: state.user.logged,
});

export default connect(mapStateToProps)(Vote);



// WEBPACK FOOTER //
// ./src/components/vote/vote.js